import { Component, OnInit, ViewChild } from '@angular/core';
import { TablasDinamicasConfigService } from '../../../services/database/tablas-dinamicas-config.service';
import { ButtonColumnType, CustomTableComponent, CustomTitle, DataColumnType, IButtonColumn, ICustomTable, IDataColumn, IHeader, LoadingPanelService } from 'lib-base';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DialogModule } from 'primeng/dialog';
import { IColumnDinamico, TablasDinamicasDatosDto } from '../../../shared/interfaces/database/tramites_automaticos';
import { ColumnType } from './dataset-dinamico-columnas';
import { getColumnAlignment } from './dataset-utils';
import { JSONParser } from '@amcharts/amcharts5';
import { DatasetVisualizarDocumentosComponent } from './dataset-visualizar-documentos.component';
import { firstValueFrom, forkJoin } from 'rxjs';

@Component({
  selector: 'app-get-dataset-historico',
  standalone: true,
  imports: [CustomTableComponent, DialogModule, CustomTitle, TranslateModule, DatasetVisualizarDocumentosComponent],
  template: `
<section>
	<p-dialog [(visible)]="displayModal" [modal]="true" [autoZIndex]="true" [draggable]="false"
		[resizable]="true" [maximizable]="true" [breakpoints]="{'640px': '100vw'}" [style]="{width: '90vw'}">

		<ng-template pTemplate="header">
			<CustomTitle [title]="'common.historial' | translate" />
		</ng-template>

		<ng-template pTemplate="content">
			<custom-table [config]="customTable">
      </custom-table>
		</ng-template>

    <ng-template pTemplate="footer">			
		</ng-template>
	</p-dialog>
</section>

<app-dataset-visualizar-documentos></app-dataset-visualizar-documentos>

  `
})
export class GetDatasetHistoricoComponent implements OnInit {

  displayModal: boolean = false;
  trans: any = {};
  customTable !: ICustomTable;
  datasetColumnas: IColumnDinamico[] = [];
  tablaDinamicaConfigId !: number;
  filaId !: any;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;
  @ViewChild(DatasetVisualizarDocumentosComponent) visualizarDocumentos!: DatasetVisualizarDocumentosComponent;
  

  constructor(private readonly _tsc: TablasDinamicasConfigService, private readonly _t: TranslateService,
    private readonly _lps: LoadingPanelService
  ) {
  }

  ngOnInit(): void {
    this.translate();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      documentos: this._t.get('common.documentos')
    }));
  }

  show(tablaDinamicaConfigId: number, filaId: number): void {
    this.tablaDinamicaConfigId = tablaDinamicaConfigId;
    this.filaId = filaId;
    this.displayModal = true;
    this.loadHistorial(tablaDinamicaConfigId, filaId);
  }

  hide() {
    this.displayModal = false;
  }

  loadHistorial(tablaDinamicaConfigId: number, filaId: number) {
    this._lps.show(true);
    this._tsc.consultarHistoricoFilaTablaDinamica(tablaDinamicaConfigId, filaId).subscribe({
      next: (data: TablasDinamicasDatosDto) => {
        this.datasetColumnas = data.datasetColumnas;
        let columnsTable: (IDataColumn | IButtonColumn<any>)[] = [];

        this.datasetColumnas.forEach((column) => {
          switch (column.type as ColumnType) {
            case ColumnType.FormDocument:
              columnsTable.push({
                field: column.name,
                header: column.displayName,
                label: this.trans.documentos,
                icon: 'pi pi-folder-open',
                class: 'button-edit p-button-outlined pt-2 pb-2',
                width: '0rem',
                buttonType: ButtonColumnType.CUSTOM,
                onClick: (event: Event, data: any, fieldName?: string) => this.openDocuments(event, data, fieldName)
              });
              break;
            default:
              columnsTable.push({
                field: column.name,
                header: column.displayName,
                class: 'font-13 ' + getColumnAlignment(column),
                columnmHeader: {
                  class: 'color-blue-2 font-13 font-bold text-left',
                },
                dataType: DataColumnType.CUSTOM,
                format: column.format
              });
              break;
          }
        });

        this.customTable = {
          header: {
          } as IHeader,
          columns: columnsTable,
          settings: {
            table: {
              rows: 10,
            }
          }
        } as ICustomTable;

        setTimeout(() => {
          this.customTableComponent.data = data.datos;
          this._lps.hide();
        }, 1);
      }
    });
  }

  //#region Visualizar Documentos
  openDocuments(event: Event, data: any, fieldName?: string): void {
    const name = fieldName ?? '';
    const column = JSONParser.parse(data[name]);
    this.visualizarDocumentos.openModal(this.tablaDinamicaConfigId, this.filaId, name, column);
  }

  //#endregion Visualizar Documentos
}
